(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const heroSwiper = new Swiper('.hero-swiper', {
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination-hero',
      clickable: true,
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-for-discovery-duo-him-her"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const heroSwiper = new Swiper('.discovery-swiper', {
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.disovery-set-pagination',
      clickable: true,
      type: 'bullets'
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
